module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/59b0fbbfc11533a02717aa7272b664f2.png";